import { RepositoryDocument } from './types';

/** What a document is called in the field: its reference, else the file it came from. */
export const documentLabel = (document: RepositoryDocument): string =>
    document.reference?.trim() ? document.reference : document.fileName;
